module.exports = __webpack_public_path__ + "img/apidays-onsite-3.bfcb6796.jpg";